import moment    from 'moment';
import Immutable from 'immutable';

import { dateFormat } from 'alto-utils/lib/utils';

import DailyMenu from './daily_menu';

export default class CanteenMenu {
  constructor(canteen, _dailyMenus, _menu) {
    this.canteen     = canteen;
    this._dailyMenus = _dailyMenus;
    this._menu       = _menu;
  }

  dates() {
    return this._menu.dates;
  }

  dailyMenus() {
    return this._dailyMenus?.map(this._dailyMenuFor.bind(this)).valueSeq() ?? new Immutable.Seq;
  }

  dailyMenuFor(date) {
    const groupMenus = this._dailyMenus?.get(date.format(dateFormat)) ?? null;

    return new DailyMenu(this.canteen, date, groupMenus, this._menu);
  }

  _dailyMenuFor(groupMenus, formattedDate) {
    return new DailyMenu(this.canteen, moment(formattedDate, dateFormat), groupMenus, this._menu);
  }
}
